import { type MetaFunction } from '@remix-run/node';
import { DocPage } from '~/components/docs-page';
import { Routes } from '~/constants/routes';

export const meta: MetaFunction = () => {
  return [
    { title: 'Brokkr Docs - Authentication' },
  ];
};

export default function BrokkrApiAuthentication() {
  return (
    <DocPage>
      <DocPage.Heading>
        <DocPage.SectionTitle>Brokkr API</DocPage.SectionTitle>
        <DocPage.PageTitle>Authentication</DocPage.PageTitle>
      </DocPage.Heading>

      <DocPage.Content>
        <p className="font-semibold">
          Key creation is guarded and you need to reach out to Hydra Host to get
          access.
        </p>

        <h2>API Keys</h2>

        <p>
          Keys are scoped to an organization. You can create multiple keys for
          different users. We recommend setting an expiration date on your keys
          to limit the impact of a key being compromised.
        </p>

        <h3>Creating a Key</h3>

        <p>
          To create a key, you can visit the API Keys section of your Brokkr
          organization.
        </p>

        <p>
          Given a name and an optional expiration date, you can create a key. It
          will be shown once and cannot be retrieved later.
        </p>

        <h3>Using a Key</h3>

        <p>
          To authenticate any requests to the Brokkr API, you need to pass the
          key in the header of your request.
        </p>

        <pre>
          <code>X-API-KEY: your_api_key_here</code>
        </pre>

        <h3>Deleting a Key</h3>

        <p>
          You can delete a key by clicking the trash icon next to the key in
          your Brokkr account.
        </p>
      </DocPage.Content>

      <DocPage.Footer>
        <DocPage.PreviousLink href={Routes.DocsBrokkrApiOverview}>
          API Overview
        </DocPage.PreviousLink>
        <DocPage.NextLink href={Routes.DocsBrokkrApiDcim}>
          DCIM
        </DocPage.NextLink>
      </DocPage.Footer>
    </DocPage>
  );
}
